export default "__VITE_ASSET__B497mNJ0__"